module.exports = __webpack_public_path__ + "img/whatsapp.c3e5ef3a.png";